import { Point, Rectangle, Matrix } from "../Utils/Matrix";
import { TopoConnection } from "../Topology/TopoConnection";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

export interface ITopoNode {
	DisplayName: string;
	Image: HTMLImageElement;
}

//export interface TopoNodeJson {
//    location_x: string;
//    location_y: string;
//    width: string;
//    height: string;
//}

//export interface TopoNodeEntryJson {
//    device_node: DeviceNodeJson;
//    hub_node: MultiNodeJson;
//    //image_node: ImageNodeJson;
//}

export class TopoNode implements ObjectSerializer {
	public static DefaultSize = 75;

	public get Location(): Point {
		return new Point(this.X, this.Y);
	}
	public set Location(value: Point) {
		this.X = value.X;
		this.Y = value.Y;
	}

	public X: number;
	public Y: number;
	public Width: number;
	public Height: number;
	public RingLayoutAngle: number = 0;

	public get Left(): number {
		return this.X;
	}
	public get Right(): number {
		return this.X + this.Width;
	}

	public get Top(): number {
		return this.Y;
	}

	public get Bottom(): number {
		return this.Y + this.Height;
	}

	public get CenterX(): number {
		return this.X + (this.Width / 2);
	}

	public get CenterY(): number {
		return this.Y + (this.Height / 2);
	}
		
	constructor() {
		this.Width = TopoNode.DefaultSize;
		this.Height = TopoNode.DefaultSize;
		this.Location = new Point(0, 0);
	}

	public ConnectionLocation(connection: TopoConnection): Point {
		return new Point(this.CenterX, this.CenterY);
	}

	public Offset(xOffset: number, yOffset: number): void {
	this.X += xOffset;
	this.Y += yOffset;
}

	public Instersects(other: TopoNode): boolean {
		if (this.X < (other.X + other.Width) && (this.X + this.Width) > other.X &&
			this.Y < (other.Y + other.Height) && (this.Y + this.Height) > other.Y)
			return true;
		else
			return false;
	}

	public GetKey(): any {
		return this;
	}

	public get Image(): HTMLImageElement {
		return new Image(48, 48);
	}

	public get DisplayName(): string {
		return "";
    }

    //public CopyTopoNodeJson(json: TopoNodeJson) {
    //    if (json.location_x !== undefined)
    //        this.X = parseInt(json.location_x);

    //    if (json.location_y !== undefined)
    //        this.Y = parseInt(json.location_y);

    //    if (json.width !== undefined)
    //        this.Width = parseInt(json.width);

    //    if (json.height !== undefined)
    //        this.Height = parseInt(json.height);
    //}

    //public static FromJson(json: TopoNodeJson): TopoNode {
    //    var result = new TopoNode();

    //    result.CopyTopoNodeJson(json);

    //    return result;
    //}

    //public static ReadNode(json: TopoNodeEntryJson): TopoNode {
    //    if (json.device_node !== undefined) {
    //        return DeviceNode.FromJson(json.device_node);
    //    }
    //    else if (json.hub_node !== undefined) {
    //        return MultiNode.FromJson(json.hub_node);
    //    }
    //    //else if (json.image_node !== undefined) {
    //    //    return ImageNode.FromJson(json.image_node);
    //    //}
    //    else {
    //        return null;
    //    }
    //}

	public Write(obj: any, context: any): void {

		// Called by subclass Write methods

		obj.location_x = ValueEncoder.EncodeInteger(this.X);
		obj.location_y = ValueEncoder.EncodeInteger(this.Y);
		obj.width = ValueEncoder.EncodeInteger(this.Width);
		obj.height = ValueEncoder.EncodeInteger(this.Height);
	}

	public Read(obj: any, context: any): void {

		// Called by subclass Read methods

		if (obj.location_x !== undefined)
			this.X = ValueEncoder.DecodeInteger(obj.location_x);
		if (obj.location_y !== undefined)
			this.Y = ValueEncoder.DecodeInteger(obj.location_y);
		if (obj.width !== undefined)
			this.Width = ValueEncoder.DecodeInteger(obj.width);
		if (obj.height !== undefined)
			this.Height = ValueEncoder.DecodeInteger(obj.height);
	}

}
